import { render, staticRenderFns } from "./RegisterGlobal.vue?vue&type=template&id=6fa45476&"
import script from "./RegisterGlobal.vue?vue&type=script&lang=js&"
export * from "./RegisterGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports